import { useState, useEffect } from 'react';
import moment from 'moment';
import { buriedPointSearch } from '@/pages/home/utils/buriedPoint';

import type { IStoreRankDetailsTablesSourceData } from '@/pages/intelligence/types/storeRank';

export default function useSearch(props: { sourceData: IStoreRankDetailsTablesSourceData[]; pageLogConfig?: any }) {
  const { sourceData: sourceDataOuter, pageLogConfig } = props ?? {};
  const sourceDataOuterTmp = Array.isArray(sourceDataOuter) ? sourceDataOuter : [];

  const [keywords, setKeywords] = useState('');
  const [sourceData, setSourceData] = useState<IStoreRankDetailsTablesSourceData[]>([]);

  const searchLog = (payload: string) => {
    if (!pageLogConfig?.pageId) return;
    buriedPointSearch({ extInfo: pageLogConfig?.pageId, typeId: pageLogConfig?.typeId }, payload);
  };

  const search = (payload: string) => {
    if (!payload) {
      setSourceData(sourceDataOuterTmp);
      return;
    }
    const sourceDatatemp = sourceDataOuterTmp.filter((item) =>
      moment(item?.date).format('YYYY-MM-DD').includes(payload),
    );
    setSourceData(sourceDatatemp);
    // console.log('keywords: ', payload);
    // console.log('sourceData: ', sourceDataOuterTmp);
    // console.log('sourceDataSearched: ', sourceDatatemp);
  };

  const handleSearch = (payload?: string) => {
    const keywordsTmp = payload?.trim() ?? '';
    setKeywords(keywordsTmp);
    if (!keywordsTmp) {
      setSourceData(sourceDataOuterTmp);
      return;
    }
    search(keywordsTmp);
    searchLog(keywordsTmp);
  };

  const handleChange = (payload?: string) => {
    const keywordsTmp = payload ?? '';
    setKeywords(keywordsTmp);
    if (!keywordsTmp) {
      setSourceData(sourceDataOuterTmp);
    }
  };

  const handleClear = () => {
    setKeywords('');
    setSourceData(sourceDataOuterTmp);
  };

  useEffect(() => {
    setKeywords('');
    setSourceData(sourceDataOuterTmp);
  }, [sourceDataOuter]);

  return {
    keywords,
    sourceData,
    onChange: handleChange,
    onSearch: handleSearch,
    onClear: handleClear,
  };
}
